import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-material-organism',
  templateUrl: './material-organism.component.html',
  styleUrls: ['./material-organism.component.scss']
})
export class MaterialOrganismComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
